import aai18nPlugin from '../plugins/i18n';

export {
    aai18nPlugin
};
